import { render, staticRenderFns } from "./HookAcciones.vue?vue&type=template&id=5b974146&"
import script from "./HookAcciones.vue?vue&type=script&lang=js&"
export * from "./HookAcciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports